import gql from 'graphql-tag'

export default gql`
  query GetMarketplaceOrder($orderReference: ID!, $cartId: UUID!) {
    marketplaceOrder(orderReference: $orderReference, cartId: $cartId) {
      orderReference
      status
      totalIncTax
      totalTax
      billingAddress {
        email
      }
      parcels {
        fulfilmentType
        fulfilmentLocation
        centreTitle
        centreServicePageURL
        shippingCost
        items {
          shop {
            name
          }
          quantity
          variant {
            title
            brand
            variantGroupCode
            price
          }
        }
      }
    }
  }
`
